<template>
  <div id="nav" v-if="$store.state.show_navbar">
      <span v-if="isLoggedIn">
        <router-link to="/profile">Профиль</router-link> |
        <router-link to="/balances">Финансы</router-link> |
        <router-link to="/account">Настройки</router-link> |
        <router-link @click.prevent="logout" to="/logout">Выйти</router-link>
      </span>
      <span v-else>
        <router-link to="/login">Войти</router-link>
      </span>
      <span v-if="localControl"> | <router-link to="/control">Абоненты</router-link></span>
      <span v-if="localControl"> | <router-link to="/control_server">Сервер</router-link></span>
      <span v-if="localControl"> | <router-link to="/control_new_users">Новые</router-link></span>
      <span v-if="isNotConnected" class="text-danger"> Нет соединения</span>
  </div>
</template>
<script>
export default {
  name: "NavBar",
  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn;
    },
    localControl: function() {
      return this.$store.getters.showControl;
    },
    isNotConnected: function (){
      return !this.$store.state.socket.isConnected;
    },
    isInvoice: function() {
      return this.$store.state.show_invoice;
    }
  },
  methods: {
    logout() {
      console.log('test')
      this.$store.dispatch("logOut");
      this.$router.push("/login");
    },
  },
};
</script>

<style>
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

a:hover {
  cursor: pointer;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
